import React from "react";
import Form from "react-validation/build/form";
import AuthService from "../../services/auth.service";

import {
    Heading,
    FormControl,
    FormLabel,
    Button,
    InputRightElement,
    InputGroup,
    Text,
    Link,
    Stack,
    Input,
    Box,
  } from '@chakra-ui/react'
import { useState } from 'react';
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';
import { ParentCard } from "../HomePage/style";
import { Card, LightBg } from "./style";
import { useNavigate } from "react-router-dom"

const required = value => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        This field is required!
      </div>
    );
  }
};

const LoginPage = () => {
  const [emailUser, setEmailUser] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [showPassword, setShowPassword] = useState();
  const [successful, setSuccessful] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await AuthService.login(emailUser, password).then(
        () => {
          if(AuthService.getCurrentUser().roles.includes("Admin")) {
            console.log("masuk admin")
            navigate("/admin/verifikasi/proposal");
            window.location.reload();
          } else {
            navigate("/");
            window.location.reload();
          }

        },
        (error) => {
          console.log(error);

          let resMessage;

          resMessage = (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
              error.message ||
              error.toString();

              console.log(resMessage);
              setMessage("Username atau password salah");
              setSuccessful(false);

        }
      );
    } catch (err) {
      console.log(err);
      setMessage("Terjadi kesalahan, coba lagi")
    }
  };

      return (
          <>
          <LightBg>
              <ParentCard>
                  <Card>
                      <Stack>
                          <Box>
                              <Heading fontFamily={'Inter'} textAlign={'center'}>Login</Heading>
                          </Box>
                          <Form 
                          onSubmit={handleLogin}>
                          <Box pt={4}>
                              <FormControl isRequired>
                              <FormLabel>Alamat email</FormLabel>
                                  <Input 
                                      id = 'emailUser'
                                      placeholder='Masukkan alamat email'
                                      name='email'
                                      value={emailUser}
                                      onChange={(e) => setEmailUser(e.target.value)}
                                      validations={[required]}/>
                              </FormControl>
                          </Box>
                          <Box pt={4}>
                              <FormControl isRequired>
                              <FormLabel>Kata sandi</FormLabel>
                                  <InputGroup>
                                      <Input 
                                          id="password"
                                          type={showPassword ? 'text' : 'password'} 
                                          placeholder='Masukkan kata sandi'
                                          name="password"
                                          value={password}
                                          onChange={(e) => setPassword(e.target.value)}
                                          validations={[required]}/>
                                      <InputRightElement h={'full'}>
                                          <Button
                                              variant={'ghost'}
                                              onClick={() =>
                                              setShowPassword((showPassword) => !showPassword)
                                              }>
                                              {showPassword ? <ViewIcon /> : <ViewOffIcon />}
                                          </Button>
                                      </InputRightElement>
                                  </InputGroup>
                              </FormControl>
                          </Box>
                          <Box align={'center'}>
                              <Button 
                                  style={{background:'#6554C0', color:'#FFFFFF', justifyContent:'center'}} 
                                  mt={4} 
                                  type='submit'>
                                      <span>Masuk</span>
                              </Button>
                              {message && (
                              //   <Alert severity="info">
                              //   <AlertTitle className="alert alert-danger">Info</AlertTitle>
                              //   {message}</strong>
                              // </Alert>
                                  <div className="form-group">
                                      <div className="alert alert-danger" role="alert">
                                      {message}
                                      </div>
                                  </div>
                              )}
                          </Box>
                          </Form>
                          <Box>
                              <Text align={'center'}>Belum punya akun? <Link href="/register" color={'blue.400'}>Daftar</Link></Text>
                          </Box>
                      </Stack>
                  </Card>
              </ParentCard>
          </LightBg>
        </>
      );
}

export default LoginPage;